export default __webpack_public_path__ + "static/media/menu_my_gifts.b50fbced.svg";